export const translations = {
  en: {
    dir: "ltr",
    nav: {
      home: "Home",
      towers: "Tower Solutions",
      materials: "Telecom Materials",
      projects: "Projects",
      industries: "Industries",
      rfq: "Request a Quotation",
      about: "About",
      howItWorks: "How It Works",
      partners: "Partners",
      contact: "Contact",
    },
    common: {
      requestQuotation: "Request Quotation",
      talkToEngineer: "Talk to an Engineer",
      requestPricing: "Request Pricing",
      requestAvailability: "Request Availability",
      uploadBOQ: "Upload BOQ",
      learnMore: "Learn More",
      getStarted: "Get Started",
      viewAll: "View All",
      typicalHeights: "Typical Heights",
      applications: "Applications",
      industriesServed: "Industries Served",
      sendMessage: "Send Message",
      next: "Next",
      back: "Back",
      submit: "Submit Request",
      optional: "Optional",
      step: "Step",
      of: "of",
      yes: "Yes",
      no: "No",
    },
    hero: {
      tagline: "Saudi Arabia & GCC Region",
      title: "The Network of Qualified Partners for Telecom & Infrastructure",
      subtitle:
        "Get competitive quotations and compare the best solutions for your project through a network of qualified suppliers, contractors, and engineering companies across Saudi Arabia and the GCC.",
      description: "",
      primaryCta: "Request Competitive Quotations",
      secondaryCta: "Submit Project Requirements",
    },
    urgent: {
      title: "Need an Urgent Quotation?",
      text: "Contact us directly on WhatsApp",
      number: "+966 54 974 7549",
      cta: "Send Urgent Request",
    },
    trust: {
      heading: "Engineering Trust at Scale",
      sub: "Delivering critical telecom infrastructure across the Kingdom and the wider GCC.",
      projects: "Projects Posted",
      rfqs: "RFQs Processed",
      towers: "Quotations Delivered",
      cities: "Cities Covered",
      partners: "Qualified Industry Contacts",
      response: "Avg. Response Time",
      responseValue: "24h",
    },
    services: {
      label: "Our Capabilities",
      heading: "End-to-End Telecom Infrastructure",
      sub: "From towers and infrastructure to materials and engineering services — one platform connecting you with qualified partners for your network rollout.",
    },
    howItWorks: {
      label: "How It Works",
      heading: "A Streamlined Path to Your Quotation",
      sub: "Submit once and let our network of qualified telecom partners compete to deliver the best technical and commercial solution.",
      steps: [
        { title: "Submit Your Project Requirements", desc: "Upload drawings, BOQs, specifications, or project details." },
        { title: "Technical Review", desc: "Our network of telecom infrastructure specialists reviews your requirements." },
        { title: "Receive Competitive Quotations", desc: "Get multiple competitive quotations from qualified suppliers and contractors." },
        { title: "Select the Best Solution", desc: "Choose the most suitable technical and commercial proposal for your project." },
      ],
    },
    whyChoose: {
      label: "Why Choose Us",
      heading: "Why Choose Our Platform",
      sub: "A single, trusted gateway to the Kingdom's telecom and infrastructure supply network.",
    },
    ourSolutions: {
      label: "Our Solutions",
      heading: "Comprehensive Solution Categories",
      sub: "From towers and infrastructure to civil projects, materials and engineering services — all under one platform.",
    },
    clientsPartners: {
      label: "Clients & Partners",
      heading: "Clients, Suppliers, Contractors & Strategic Partners",
      sub: "A growing network of trusted operators, suppliers, contractors and strategic partners across the region.",
    },
    clients: {
      label: "Trusted By",
      heading: "Operators, EPC Contractors & Government Projects",
    },
    recommender: {
      label: "Smart Tool",
      heading: "Smart Tower Recommendation",
      sub: "Answer a few questions and our engineering logic will recommend the optimal tower type, height and solution for your site.",
      q_purpose: "Primary Purpose",
      q_environment: "Site Environment",
      q_coverage: "Coverage / Height Need",
      q_space: "Available Ground Space",
      purpose_macro: "Macro Cellular Coverage",
      purpose_smallcell: "Small Cell / Densification",
      purpose_microwave: "Microwave / Backhaul",
      purpose_broadcast: "Broadcast / High Power",
      env_urban: "Urban / City",
      env_rural: "Rural / Desert",
      env_rooftop: "Building Rooftop",
      env_industrial: "Industrial / Oil & Gas",
      cov_low: "Low (up to 15m)",
      cov_med: "Medium (15–30m)",
      cov_high: "High (30m+)",
      space_limited: "Limited",
      space_moderate: "Moderate",
      space_ample: "Ample",
      getRecommendation: "Get Recommendation",
      recalculate: "Recalculate",
      resultTitle: "Recommended Solution",
      recTowerType: "Recommended Tower Type",
      recHeight: "Suggested Height",
      recSolution: "Suggested Solution",
      proceedQuote: "Request Detailed Quotation",
    },
    towersPage: {
      label: "Tower Solutions",
      heading: "Structural Telecom Towers",
      sub: "Engineered, fabricated and installed to international and operator-specific standards.",
    },
    materialsPage: {
      label: "Telecom Materials",
      heading: "Telecom Materials Catalog",
      sub: "A comprehensive catalog of network materials. This is a professional catalog — request pricing, availability, or upload your BOQ for a tailored quotation.",
      note: "This is not an online store. All items are quoted per project requirements and BOQ.",
    },
    projectsPage: {
      label: "Project Portfolio",
      heading: "Delivered Projects",
      sub: "A selection of tower installations, civil works, foundations and fiber deployments across the region.",
      filters: { all: "All", towers: "Telecom Towers", infrastructure: "Infrastructure", buildings: "Buildings", materials: "Telecom Materials", engineering: "Engineering Services" },
    },
    industriesPage: {
      label: "Industries We Serve",
      heading: "Sectors We Power",
      sub: "Specialized telecom and infrastructure delivery tailored to the demands of each sector.",
    },
    rfqPage: {
      label: "Request a Quotation",
      heading: "Build Your Quotation Request",
      sub: "Complete the steps below. Our engineering team and partner network will respond with detailed technical and commercial proposals.",
      sNeed: "What Do You Need?",
      sTowerType: "Tower Type",
      sTowerHeight: "Tower Height",
      sTowerQuantity: "Number of Towers",
      sTowerConfig: "Tower Configuration",
      towerConfigDescLabel: "Please describe tower types and quantities",
      towerConfigDescPlaceholder: "e.g. 2x Monopole 30m, 1x Self-Support 40m...",
      sStandards: "Required Standards",
      sScope: "Scope of Work",
      sInfraType: "Infrastructure Type",
      sInfraScale: "Project Scale",
      sBuildingType: "Building Type",
      sBuildingArea: "Built-up Area",
      sBuildingFloors: "Number of Floors",
      sMaterialCategory: "Material Categories",
      sMaterialQuantity: "Required Quantity",
      sMaterialPurpose: "Purpose",
      sEngService: "Required Services",
      sEngProjectType: "Project Type",
      sEngDeliverable: "Required Deliverables",
      sStatus: "Project Status",
      sDelivery: "Required Delivery & Execution Time",
      sPriority: "Project Priority",
      sDocuments: "Project Documents",
      sLocation: "Project Location",
      sCustomer: "Customer Information",
      docsQuestion: "Do you have project documents?",
      country: "Country",
      city: "City",
      projectName: "Project Name",
      siteName: "Site Name",
      gps: "GPS Coordinates",
      mapsLink: "Google Maps Link",
      dropFiles: "Drag & drop files here, or click to browse",
      fileTypes: "BOQ, Drawings, Specifications, Site Photos, Tender Documents, Structural Calculations, Google Earth Images",
      uploading: "Uploading...",
      fullName: "Full Name",
      company: "Company Name",
      position: "Position",
      email: "Email",
      mobile: "Phone",
      whatsapp: "WhatsApp",
      notes: "Additional Notes",
      warrantyMsg: "Selected projects may qualify for warranty programs and after-sales support through approved partners, subject to project scope and partner terms.",
      successTitle: "Request Submitted Successfully",
      successMsg: "Thank you. Your quotation request has been received and shared with our qualified partner network. You will receive competitive quotations shortly.",
      reference: "Your reference number",
      newRequest: "Submit Another Request",
      selectRequired: "Please make a selection to continue.",
      selectPlaceholder: "Select...",
      sDescription: "Project Details",
      descGeneral: "Project Description / Additional Requirements",
      descMaterials: "Required Materials / Specifications",
      descEng: "Engineering Requirements / Project Details",
      descOther: "Describe Your Requirements",
      descPlaceholder: "Please describe your requirements, specifications, quantities, standards, timeline, and any special requests in detail...",
      descHint: "This field is required.",
      invalidEmail: "Enter a valid email address (e.g. name@example.com).",
      invalidPhone: "Enter a valid number: 8–15 digits, “+” allowed only at the start.",
    },
    aboutPage: {
      label: "About Us",
      heading: "The Telecom Procurement & RFQ Platform for Saudi Arabia & the GCC",
      intro:
        "TowerLink is a telecom procurement, RFQ, and business-matching platform. We connect project owners with qualified suppliers, contractors, and engineering companies across Saudi Arabia and the GCC — so you can source the right partner for any telecom or infrastructure requirement through a single request.",
      whatHeading: "What is TowerLink?",
      whatBody:
        "TowerLink is not a contractor, supplier, or engineering consultancy. We are a neutral platform that brings the telecom supply market together in one place. Project owners submit their requirements once, and we match them with relevant, qualified companies who compete to provide the best technical and commercial offer.",
      problemHeading: "The Problem We Solve",
      problemBody:
        "Sourcing telecom towers, infrastructure, materials, or engineering services traditionally means contacting suppliers one by one — a slow process with limited market reach and little price comparison. TowerLink replaces that with a single RFQ that instantly reaches a network of qualified partners.",
      howHeading: "How We Connect You",
      howBody:
        "When you submit an RFQ, TowerLink reviews your requirements and shares them with suitable, qualified suppliers, contractors, and engineering companies in our network. You then receive multiple competitive quotations and can compare proposals side by side.",
      coverageHeading: "Regional Coverage",
      coverageBody:
        "Our partner network spans Saudi Arabia and the wider GCC region, covering telecom towers, infrastructure, civil and building projects, telecom materials, and engineering services.",
      missionHeading: "Our Mission",
      missionBody:
        "To simplify telecom procurement across the GCC by giving project owners fast, transparent access to a competitive network of qualified suppliers and contractors.",
      visionHeading: "Our Vision",
      visionBody:
        "To become the leading telecom and infrastructure procurement platform in Saudi Arabia and the GCC — the first place project owners and suppliers go to do business.",
      whyHeading: "Why TowerLink?",
      whyBody:
        "Unlike contacting a single supplier or contractor directly, TowerLink provides access to a network of qualified suppliers, contractors, and engineering partners across Saudi Arabia and the GCC. Through one RFQ submission, clients can reach multiple qualified companies, compare competitive quotations, evaluate technical proposals, and identify the most suitable solution for their project requirements. Our goal is to help clients save time, increase market reach, improve supplier competition, and achieve better value for their projects.",
      whyTagline: "One RFQ. Multiple Qualified Partners. Better Commercial Opportunities.",
      differentHeading: "What Makes Us Different",
    },
    contactPage: {
      label: "Get in Touch",
      heading: "Talk to Our Engineers",
      sub: "Reach out for project inquiries, RFQs, or technical consultations. Our team responds within one business day.",
      formHeading: "Business Inquiry Form",
      subject: "Subject",
      message: "Message",
      email: "Email",
      phone: "Phone",
      whatsapp: "WhatsApp",
      address: "Coverage",
      addressValue: "Serving Saudi Arabia & GCC Region",
      successMsg: "Thank you. Your message has been sent. We'll be in touch shortly.",
    },
    footer: {
      tagline: "A telecom procurement and RFQ platform connecting project owners with qualified suppliers, contractors, and engineering companies across Saudi Arabia and the GCC.",
      quickLinks: "Quick Links",
      solutions: "Solutions",
      company: "Company",
      contact: "Contact",
      aboutUs: "About Us",
      howItWorks: "How It Works",
      partners: "Partners",
      privacy: "Privacy Policy",
      terms: "Terms & Conditions",
      disclaimer: "Disclaimer",
      contactUs: "Contact Us",
      emailUs: "Email Us",
      serving: "Serving Saudi Arabia & GCC Region",
      rights: "All rights reserved.",
    },
    cta: {
      heading: "Have a project or a BOQ ready?",
      sub: "Submit your requirements and receive a detailed engineering quotation within 24 hours.",
    },
    howItWorksPage: {
      label: "How It Works",
      heading: "How TowerLink Works",
      sub: "From a single RFQ to multiple competitive quotations — a simple, transparent path to the best offer for your project.",
      steps: [
        { title: "Submit Your RFQ", desc: "Tell us what you need — telecom towers, infrastructure, civil works, materials, or engineering services. Submit your requirements once through our guided RFQ form." },
        { title: "TowerLink Reviews Your Requirements", desc: "Our team reviews your request to ensure it is clear and complete, then identifies the most relevant qualified partners for your scope." },
        { title: "Qualified Suppliers Receive Your RFQ", desc: "Your requirements are shared with suitable, qualified suppliers, contractors, and engineering companies in our network across Saudi Arabia and the GCC." },
        { title: "Receive Competitive Quotations", desc: "Interested partners respond with their technical and commercial proposals, giving you multiple competitive quotations to review." },
        { title: "Select the Best Offer", desc: "Compare quotations side by side, evaluate the proposals, and choose the partner that best fits your project. The agreement is made directly with the selected partner." },
      ],
    },
    privacyPage: {
      label: "Privacy Policy",
      heading: "Privacy Policy",
      updated: "Last updated: June 2026",
      intro: "This Privacy Policy explains how TowerLink collects, uses, shares, and protects the information you provide when using our platform. By submitting an RFQ or contacting us, you agree to the practices described below.",
      sections: [
        { title: "Information We Collect", body: "We collect the information you provide directly to us, including your name, company name, position, email address, phone and WhatsApp numbers, project location, and the details of your requirements." },
        { title: "RFQ Information", body: "When you submit a Request for Quotation, we collect the project details you provide — such as requirement type, specifications, quantities, standards, timelines, and any documents you upload — so that qualified partners can prepare accurate quotations." },
        { title: "Contact Information", body: "Your contact details are used to communicate with you about your request, share quotations, and respond to inquiries. We do not display your contact details publicly." },
        { title: "Data Sharing with Qualified Suppliers", body: "To fulfil the purpose of the platform, your RFQ and relevant project details are shared with qualified suppliers, contractors, and engineering companies in our network so they can submit competitive quotations. We share only the information necessary for partners to respond to your request." },
        { title: "Security Measures", body: "We apply reasonable technical and organisational measures to protect your information against unauthorised access, loss, or misuse. However, no method of transmission or storage is completely secure." },
        { title: "Your Rights", body: "You may request access to, correction of, or deletion of your personal information at any time by contacting us. We will respond to legitimate requests in line with applicable regulations." },
        { title: "Contact Us", body: "If you have any questions about this Privacy Policy or how your data is handled, please reach us through the channels provided on our Contact page." },
      ],
    },
    termsPage: {
      label: "Terms & Conditions",
      heading: "Terms & Conditions",
      updated: "Last updated: June 2026",
      intro: "These Terms & Conditions govern your use of the TowerLink platform. By using the platform or submitting an RFQ, you agree to these terms.",
      sections: [
        { title: "Nature of the Platform", body: "TowerLink is a business-matching and RFQ platform. TowerLink is not a contractor, supplier, consultant, or project executor. We do not manufacture, supply, install, or execute any works ourselves." },
        { title: "Our Role", body: "TowerLink acts solely as an intermediary that connects project owners with qualified suppliers, contractors, and engineering companies, and facilitates the exchange of requirements and quotations between them." },
        { title: "Agreements Between Parties", body: "Any quotation, negotiation, contract, or agreement resulting from the platform is strictly between the client and the selected supplier or contractor. TowerLink is not a party to any such agreement." },
        { title: "No Guarantee", body: "TowerLink does not guarantee the accuracy of quotations, the availability of products or services, the performance of any partner, or the outcome of any project. All offers are provided by third-party partners." },
        { title: "User Responsibilities", body: "You are responsible for providing accurate information in your requests, for evaluating the proposals you receive, and for conducting your own due diligence before entering into any agreement." },
        { title: "Limitation of Liability", body: "To the maximum extent permitted by law, TowerLink shall not be liable for any loss or damage arising from the use of the platform or from any agreement or dealing between a client and a partner." },
        { title: "Changes to These Terms", body: "We may update these Terms & Conditions from time to time. Continued use of the platform after changes constitutes acceptance of the updated terms." },
      ],
    },
    disclaimerPage: {
      label: "Disclaimer",
      heading: "Disclaimer",
      updated: "Last updated: June 2026",
      intro: "TowerLink is a business-matching platform that connects project owners with qualified suppliers, contractors, and engineering companies. The following disclaimer applies to all use of the platform.",
      sections: [
        { title: "Platform Role Only", body: "TowerLink only facilitates connections and the exchange of RFQs and quotations between clients and third-party partners. We are not a supplier, contractor, consultant, or project executor." },
        { title: "We Are Not Responsible For", body: "• Supplier performance\n• Contract disputes\n• Pricing accuracy\n• Project execution\n• Payment disputes\n• Third-party services" },
        { title: "Independent Decisions", body: "Any decision to engage a supplier or contractor, and any resulting agreement, is made independently by the client. TowerLink does not endorse or guarantee any partner." },
        { title: "No Warranty", body: "The platform and its content are provided on an \"as is\" basis without warranties of any kind. TowerLink does not warrant that the platform will be uninterrupted, error-free, or that quotations will meet your requirements." },
        { title: "Limitation", body: "TowerLink shall not be held liable for any direct, indirect, or consequential loss arising from dealings between clients and partners or from reliance on information provided through the platform." },
      ],
    },
    partnersPage: {
      label: "Partners",
      heading: "Join Our Partner Network",
      intro: "Join TowerLink's growing network of verified suppliers, contractors, and engineering partners across Saudi Arabia and the GCC. Receive qualified project opportunities and connect with serious project owners through a specialized telecom procurement and RFQ platform.",
      formHeading: "Partner Registration",
      companyName: "Company Name",
      crNumber: "Commercial Registration Number",
      contactPerson: "Contact Person",
      position: "Position",
      email: "Email",
      phone: "Phone",
      whatsapp: "WhatsApp",
      country: "Country",
      city: "City",
      website: "Website",
      categoriesLabel: "Business Category",
      categoriesHint: "Select all that apply",
      yearsExperience: "Years of Experience",
      companyDescription: "Company Description",
      docsLabel: "Documents & Certifications",
      docsHint: "Upload your Commercial Registration, Company Profile (PDF), ISO Certificates, Aramco / STC / SEC Approvals, and any other certifications.",
      dropFiles: "Drag & drop files here, or click to browse",
      uploading: "Uploading...",
      submit: "Submit Registration",
      successTitle: "Application Received",
      successMsg: "Thank you for registering with TowerLink. Your application has been received and is currently under review. Our team will verify the submitted information before activating your partner status.",
      yourPartnerId: "Your Partner ID",
      referenceLabel: "Your Reference Number",
      newRegistration: "Submit Another Registration",
      verifiedHeading: "Our Verified Partners",
      verifiedSub: "A growing network of verified suppliers, contractors, and engineering companies across Saudi Arabia and the GCC.",
      verifiedEmpty: "Our verified partner network is growing. Approved partners will appear here.",
      colPartnerId: "Partner ID",
      colCategory: "Category",
      colCountry: "Country",
      colStatus: "Status",
      statusVerified: "Verified Partner",
      invalidEmail: "Enter a valid email address (e.g. name@example.com).",
      invalidPhone: "Enter a valid number: 8–15 digits, “+” allowed only at the start.",
      requiredFields: "Please complete all required fields.",
      selectCategory: "Please select at least one business category.",
    },
    homePartner: {
      eyebrow: "Partner Network",
      heading: "Are You a Supplier, Contractor or Engineering Company?",
      text: "Join TowerLink's growing network of verified partners across Saudi Arabia and the GCC.",
      support: "Register your company, upload your accreditation documents, and receive qualified project opportunities through TowerLink's growing network.",
      cta: "Join Our Partner Network",
      trust: [
        { title: "Trusted Network", sub: "Verified Partners" },
        { title: "More Opportunities", sub: "Ongoing Projects" },
        { title: "Regional Coverage", sub: "Saudi Arabia & the GCC" },
        { title: "High Standards", sub: "Quality & Professionalism" },
      ],
    },
  },
  ar: {
    dir: "rtl",
    nav: {
      home: "الرئيسية",
      towers: "حلول الأبراج",
      materials: "مواد الاتصالات",
      projects: "المشاريع",
      industries: "القطاعات",
      rfq: "طلب عرض سعر",
      about: "من نحن",
      howItWorks: "كيف تعمل",
      partners: "الشركاء",
      contact: "اتصل بنا",
    },
    common: {
      requestQuotation: "طلب عرض سعر",
      talkToEngineer: "تحدث إلى مهندس",
      requestPricing: "طلب التسعير",
      requestAvailability: "طلب التوفر",
      uploadBOQ: "رفع جدول الكميات",
      learnMore: "اعرف المزيد",
      getStarted: "ابدأ الآن",
      viewAll: "عرض الكل",
      typicalHeights: "الارتفاعات المعتادة",
      applications: "التطبيقات",
      industriesServed: "القطاعات المخدومة",
      sendMessage: "إرسال الرسالة",
      next: "التالي",
      back: "السابق",
      submit: "إرسال الطلب",
      optional: "اختياري",
      step: "خطوة",
      of: "من",
      yes: "نعم",
      no: "لا",
    },
    hero: {
      tagline: "المملكة العربية السعودية ودول الخليج",
      title: "شبكة الشركاء المؤهلين لقطاع الاتصالات والبنية التحتية",
      subtitle:
        "احصل على عروض أسعار تنافسية وقارن بين أفضل الحلول لمشروعك من خلال شبكة تضم الموردين والمقاولين والشركات الهندسية المؤهلة في المملكة العربية السعودية ودول الخليج.",
      description: "",
      primaryCta: "اطلب عروض أسعار تنافسية",
      secondaryCta: "إرسال متطلبات المشروع",
    },
    urgent: {
      title: "هل تحتاج عرض سعر عاجل؟",
      text: "تواصل معنا مباشرة عبر واتساب",
      number: "+966 54 974 7549",
      cta: "إرسال طلب عاجل",
    },
    trust: {
      heading: "ثقة هندسية واسعة النطاق",
      sub: "تقديم بنية تحتية حيوية للاتصالات في جميع أنحاء المملكة ودول الخليج.",
      projects: "مشاريع مطروحة",
      rfqs: "طلبات الأسعار المعالجة",
      towers: "عروض أسعار مقدمة",
      cities: "المدن المغطاة",
      partners: "جهات اتصال صناعية مؤهلة",
      response: "متوسط وقت الاستجابة",
      responseValue: "٢٤ ساعة",
    },
    services: {
      label: "قدراتنا",
      heading: "بنية تحتية متكاملة للاتصالات",
      sub: "من الأبراج والبنية التحتية إلى المواد والخدمات الهندسية — منصة واحدة تربطك بشركاء مؤهلين لنشر شبكتك.",
    },
    howItWorks: {
      label: "كيف تعمل المنصة",
      heading: "مسار مبسّط للحصول على عرض السعر",
      sub: "أرسل متطلباتك مرة واحدة ودع شبكتنا من الشركاء المؤهلين تتنافس لتقديم أفضل حل فني وتجاري.",
      steps: [
        { title: "أرسل متطلبات مشروعك", desc: "ارفع المخططات وجداول الكميات والمواصفات أو تفاصيل المشروع." },
        { title: "المراجعة الفنية", desc: "تقوم شبكتنا من متخصصي البنية التحتية للاتصالات بمراجعة متطلباتك." },
        { title: "استلم عروض أسعار تنافسية", desc: "احصل على عروض أسعار تنافسية متعددة من موردين ومقاولين مؤهلين." },
        { title: "اختر الحل الأفضل", desc: "اختر أنسب عرض فني وتجاري لمشروعك." },
      ],
    },
    whyChoose: {
      label: "لماذا نحن",
      heading: "لماذا تختار منصتنا",
      sub: "بوابة واحدة وموثوقة لشبكة توريد الاتصالات والبنية التحتية في المملكة.",
    },
    ourSolutions: {
      label: "حلولنا",
      heading: "فئات حلول شاملة",
      sub: "من الأبراج والبنية التحتية إلى المشاريع المدنية والمواد والخدمات الهندسية — كل ذلك في منصة واحدة.",
    },
    clientsPartners: {
      label: "العملاء والشركاء",
      heading: "العملاء والموردون والمقاولون والشركاء الاستراتيجيون",
      sub: "شبكة متنامية من المشغلين والموردين والمقاولين والشركاء الاستراتيجيين الموثوقين في المنطقة.",
    },
    clients: {
      label: "موثوق به من",
      heading: "المشغلون والمقاولون والمشاريع الحكومية",
    },
    recommender: {
      label: "أداة ذكية",
      heading: "توصية البرج الذكية",
      sub: "أجب عن بعض الأسئلة وسيوصي منطقنا الهندسي بأفضل نوع برج وارتفاع وحل لموقعك.",
      q_purpose: "الغرض الأساسي",
      q_environment: "بيئة الموقع",
      q_coverage: "احتياج التغطية / الارتفاع",
      q_space: "المساحة الأرضية المتاحة",
      purpose_macro: "تغطية خلوية واسعة",
      purpose_smallcell: "خلايا صغيرة / تكثيف",
      purpose_microwave: "ميكروويف / نقل",
      purpose_broadcast: "بث / قدرة عالية",
      env_urban: "حضري / مدينة",
      env_rural: "ريفي / صحراء",
      env_rooftop: "سطح مبنى",
      env_industrial: "صناعي / نفط وغاز",
      cov_low: "منخفض (حتى ١٥م)",
      cov_med: "متوسط (١٥–٣٠م)",
      cov_high: "عالٍ (٣٠م+)",
      space_limited: "محدودة",
      space_moderate: "متوسطة",
      space_ample: "واسعة",
      getRecommendation: "احصل على التوصية",
      recalculate: "إعادة الحساب",
      resultTitle: "الحل الموصى به",
      recTowerType: "نوع البرج الموصى به",
      recHeight: "الارتفاع المقترح",
      recSolution: "الحل المقترح",
      proceedQuote: "اطلب عرض سعر مفصل",
    },
    towersPage: {
      label: "حلول الأبراج",
      heading: "أبراج اتصالات إنشائية",
      sub: "مصممة ومصنعة ومركبة وفق المعايير الدولية ومتطلبات المشغلين.",
    },
    materialsPage: {
      label: "مواد الاتصالات",
      heading: "كتالوج مواد الاتصالات",
      sub: "كتالوج شامل لمواد الشبكة. هذا كتالوج احترافي — اطلب التسعير أو التوفر أو ارفع جدول الكميات للحصول على عرض مخصص.",
      note: "هذا ليس متجراً إلكترونياً. تُسعّر جميع المواد حسب متطلبات المشروع وجدول الكميات.",
    },
    projectsPage: {
      label: "معرض المشاريع",
      heading: "المشاريع المنفذة",
      sub: "مجموعة مختارة من تركيبات الأبراج والأعمال المدنية والأساسات ونشر الألياف في المنطقة.",
      filters: { all: "الكل", towers: "أبراج الاتصالات", infrastructure: "البنية التحتية", buildings: "المباني", materials: "مواد الاتصالات", engineering: "الخدمات الهندسية" },
    },
    industriesPage: {
      label: "القطاعات التي نخدمها",
      heading: "القطاعات التي نمكّنها",
      sub: "تنفيذ متخصص للاتصالات والبنية التحتية مصمم لمتطلبات كل قطاع.",
    },
    rfqPage: {
      label: "طلب عرض سعر",
      heading: "أنشئ طلب عرض السعر",
      sub: "أكمل الخطوات أدناه. سيرد فريقنا الهندسي وشبكة شركائنا بعروض فنية وتجارية مفصلة.",
      sNeed: "ما الذي تحتاجه؟",
      sTowerType: "نوع البرج",
      sTowerHeight: "ارتفاع البرج",
      sTowerQuantity: "عدد الأبراج",
      sTowerConfig: "تكوين الأبراج",
      towerConfigDescLabel: "يرجى وصف أنواع الأبراج والكميات",
      towerConfigDescPlaceholder: "مثال: ٢ برج أحادي ٣٠م، ١ ذاتي الدعم ٤٠م...",
      sStandards: "المعايير المطلوبة",
      sScope: "نطاق العمل",
      sInfraType: "نوع البنية التحتية",
      sInfraScale: "نطاق المشروع",
      sBuildingType: "نوع المبنى",
      sBuildingArea: "المساحة المبنية",
      sBuildingFloors: "عدد الطوابق",
      sMaterialCategory: "فئات المواد",
      sMaterialQuantity: "الكمية المطلوبة",
      sMaterialPurpose: "الغرض",
      sEngService: "الخدمات المطلوبة",
      sEngProjectType: "نوع المشروع",
      sEngDeliverable: "المخرجات المطلوبة",
      sStatus: "حالة المشروع",
      sDelivery: "وقت التسليم والتنفيذ المطلوب",
      sPriority: "أولوية المشروع",
      sDocuments: "وثائق المشروع",
      sLocation: "موقع المشروع",
      sCustomer: "معلومات العميل",
      docsQuestion: "هل لديك وثائق للمشروع؟",
      country: "الدولة",
      city: "المدينة",
      projectName: "اسم المشروع",
      siteName: "اسم الموقع",
      gps: "إحداثيات GPS",
      mapsLink: "رابط خرائط جوجل",
      dropFiles: "اسحب وأفلت الملفات هنا، أو انقر للتصفح",
      fileTypes: "جدول الكميات، المخططات، المواصفات، صور الموقع، وثائق المناقصة، الحسابات الإنشائية، صور جوجل إيرث",
      uploading: "جاري الرفع...",
      fullName: "الاسم الكامل",
      company: "اسم الشركة",
      position: "المنصب",
      email: "البريد الإلكتروني",
      mobile: "الهاتف",
      whatsapp: "واتساب",
      notes: "ملاحظات إضافية",
      warrantyMsg: "قد تتأهل مشاريع مختارة لبرامج ضمان ودعم ما بعد البيع عبر شركاء معتمدين، وفقاً لنطاق المشروع وشروط الشريك.",
      successTitle: "تم إرسال الطلب بنجاح",
      successMsg: "شكراً لك. تم استلام طلب عرض السعر ومشاركته مع شبكة شركائنا المؤهلين. ستصلك عروض أسعار تنافسية قريباً.",
      reference: "رقم المرجع الخاص بك",
      newRequest: "إرسال طلب آخر",
      selectRequired: "الرجاء الاختيار للمتابعة.",
      selectPlaceholder: "اختر...",
      sDescription: "تفاصيل المشروع",
      descGeneral: "وصف المشروع / متطلبات إضافية",
      descMaterials: "المواد المطلوبة / المواصفات",
      descEng: "المتطلبات الهندسية / تفاصيل المشروع",
      descOther: "صف متطلباتك",
      descPlaceholder: "يرجى وصف متطلباتك والمواصفات والكميات والمعايير والجدول الزمني وأي طلبات خاصة بالتفصيل...",
      descHint: "هذا الحقل مطلوب.",
      invalidEmail: "أدخل بريداً إلكترونياً صحيحاً (مثال: name@example.com).",
      invalidPhone: "أدخل رقماً صحيحاً: ٨–١٥ رقماً، ويُسمح بعلامة + في البداية فقط.",
    },
    aboutPage: {
      label: "من نحن",
      heading: "منصة مشتريات وعروض أسعار الاتصالات في المملكة العربية السعودية ودول الخليج",
      intro:
        "تاورلينك منصة لمشتريات الاتصالات وطلبات عروض الأسعار ومطابقة الأعمال. نربط أصحاب المشاريع بموردين ومقاولين وشركات هندسية مؤهلين في المملكة العربية السعودية ودول الخليج — لتتمكن من إيجاد الشريك المناسب لأي متطلب اتصالات أو بنية تحتية من خلال طلب واحد.",
      whatHeading: "ما هي تاورلينك؟",
      whatBody:
        "تاورلينك ليست مقاولاً أو مورداً أو شركة استشارات هندسية. نحن منصة محايدة تجمع سوق توريد الاتصالات في مكان واحد. يقدم أصحاب المشاريع متطلباتهم مرة واحدة، ونقوم بمطابقتها مع شركات مؤهلة ذات صلة تتنافس لتقديم أفضل عرض فني وتجاري.",
      problemHeading: "المشكلة التي نحلها",
      problemBody:
        "يتطلب توريد أبراج الاتصالات أو البنية التحتية أو المواد أو الخدمات الهندسية تقليدياً التواصل مع الموردين واحداً تلو الآخر — عملية بطيئة بوصول محدود للسوق ومقارنة أسعار ضعيفة. تستبدل تاورلينك ذلك بطلب عرض سعر واحد يصل فوراً إلى شبكة من الشركاء المؤهلين.",
      howHeading: "كيف نربطك",
      howBody:
        "عند تقديم طلب عرض السعر، تراجع تاورلينك متطلباتك وتشاركها مع موردين ومقاولين وشركات هندسية مؤهلين ومناسبين في شبكتنا. ثم تستلم عروض أسعار تنافسية متعددة ويمكنك مقارنة المقترحات جنباً إلى جنب.",
      coverageHeading: "التغطية الإقليمية",
      coverageBody:
        "تمتد شبكة شركائنا عبر المملكة العربية السعودية ومنطقة الخليج، وتشمل أبراج الاتصالات والبنية التحتية والمشاريع المدنية والمباني ومواد الاتصالات والخدمات الهندسية.",
      missionHeading: "مهمتنا",
      missionBody:
        "تبسيط مشتريات الاتصالات في دول الخليج من خلال منح أصحاب المشاريع وصولاً سريعاً وشفافاً إلى شبكة تنافسية من الموردين والمقاولين المؤهلين.",
      visionHeading: "رؤيتنا",
      visionBody:
        "أن نصبح المنصة الرائدة لمشتريات الاتصالات والبنية التحتية في المملكة ودول الخليج — الوجهة الأولى لأصحاب المشاريع والموردين لإنجاز الأعمال.",
      whyHeading: "لماذا تاورلينك؟",
      whyBody:
        "على عكس التواصل مع مورد أو مقاول واحد مباشرة، توفر تاورلينك الوصول إلى شبكة من الموردين والمقاولين والشركاء الهندسيين المؤهلين في المملكة ودول الخليج. من خلال طلب عرض سعر واحد، يمكن للعملاء الوصول إلى شركات مؤهلة متعددة، ومقارنة عروض الأسعار التنافسية، وتقييم المقترحات الفنية، وتحديد الحل الأنسب لمتطلبات مشروعهم. هدفنا مساعدة العملاء على توفير الوقت وزيادة الوصول للسوق وتحسين المنافسة بين الموردين وتحقيق قيمة أفضل لمشاريعهم.",
      whyTagline: "طلب عرض سعر واحد. شركاء مؤهلون متعددون. فرص تجارية أفضل.",
      differentHeading: "ما الذي يميّزنا",
    },
    contactPage: {
      label: "تواصل معنا",
      heading: "تحدث إلى مهندسينا",
      sub: "تواصل لطلبات المشاريع أو عروض الأسعار أو الاستشارات الفنية. يرد فريقنا خلال يوم عمل واحد.",
      formHeading: "نموذج استفسار الأعمال",
      subject: "الموضوع",
      message: "الرسالة",
      email: "البريد الإلكتروني",
      phone: "الهاتف",
      whatsapp: "واتساب",
      address: "التغطية",
      addressValue: "نخدم المملكة العربية السعودية ودول الخليج",
      successMsg: "شكراً لك. تم إرسال رسالتك. سنتواصل معك قريباً.",
    },
    footer: {
      tagline: "منصة لمشتريات وطلبات عروض أسعار الاتصالات تربط أصحاب المشاريع بموردين ومقاولين وشركات هندسية مؤهلين في المملكة العربية السعودية ودول الخليج.",
      quickLinks: "روابط سريعة",
      solutions: "الحلول",
      company: "الشركة",
      contact: "اتصل بنا",
      aboutUs: "من نحن",
      howItWorks: "كيف تعمل",
      partners: "الشركاء",
      privacy: "سياسة الخصوصية",
      terms: "الشروط والأحكام",
      disclaimer: "إخلاء المسؤولية",
      contactUs: "اتصل بنا",
      emailUs: "راسلنا عبر البريد",
      serving: "نخدم المملكة العربية السعودية ودول الخليج",
      rights: "جميع الحقوق محفوظة.",
    },
    cta: {
      heading: "هل لديك مشروع أو جدول كميات جاهز؟",
      sub: "أرسل متطلباتك واحصل على عرض هندسي مفصل خلال ٢٤ ساعة.",
    },
    howItWorksPage: {
      label: "كيف تعمل",
      heading: "كيف تعمل تاورلينك",
      sub: "من طلب عرض سعر واحد إلى عروض أسعار تنافسية متعددة — مسار بسيط وشفاف للوصول إلى أفضل عرض لمشروعك.",
      steps: [
        { title: "قدّم طلب عرض السعر", desc: "أخبرنا بما تحتاجه — أبراج اتصالات أو بنية تحتية أو أعمال مدنية أو مواد أو خدمات هندسية. أرسل متطلباتك مرة واحدة عبر نموذج طلب عرض السعر الموجّه." },
        { title: "تراجع تاورلينك متطلباتك", desc: "يراجع فريقنا طلبك للتأكد من وضوحه واكتماله، ثم يحدد الشركاء المؤهلين الأكثر ملاءمة لنطاق عملك." },
        { title: "يستلم الموردون المؤهلون طلبك", desc: "تتم مشاركة متطلباتك مع موردين ومقاولين وشركات هندسية مؤهلين ومناسبين في شبكتنا عبر المملكة ودول الخليج." },
        { title: "استلم عروض أسعار تنافسية", desc: "يرد الشركاء المهتمون بمقترحاتهم الفنية والتجارية، لتحصل على عروض أسعار تنافسية متعددة لمراجعتها." },
        { title: "اختر أفضل عرض", desc: "قارن العروض جنباً إلى جنب، وقيّم المقترحات، واختر الشريك الأنسب لمشروعك. ويُبرم الاتفاق مباشرةً مع الشريك المختار." },
      ],
    },
    privacyPage: {
      label: "سياسة الخصوصية",
      heading: "سياسة الخصوصية",
      updated: "آخر تحديث: يونيو ٢٠٢٦",
      intro: "توضح سياسة الخصوصية هذه كيفية جمع تاورلينك للمعلومات التي تقدمها واستخدامها ومشاركتها وحمايتها عند استخدام منصتنا. بتقديمك طلب عرض سعر أو تواصلك معنا، فإنك توافق على الممارسات الموضحة أدناه.",
      sections: [
        { title: "المعلومات التي نجمعها", body: "نجمع المعلومات التي تقدمها لنا مباشرةً، بما في ذلك اسمك واسم شركتك ومنصبك وبريدك الإلكتروني وأرقام الهاتف والواتساب وموقع المشروع وتفاصيل متطلباتك." },
        { title: "معلومات طلب عرض السعر", body: "عند تقديم طلب عرض سعر، نجمع تفاصيل المشروع التي تقدمها — مثل نوع المتطلب والمواصفات والكميات والمعايير والجداول الزمنية وأي مستندات ترفعها — حتى يتمكن الشركاء المؤهلون من إعداد عروض دقيقة." },
        { title: "معلومات التواصل", body: "تُستخدم بيانات تواصلك للتواصل معك بشأن طلبك ومشاركة عروض الأسعار والرد على الاستفسارات. لا نعرض بيانات تواصلك علناً." },
        { title: "مشاركة البيانات مع الموردين المؤهلين", body: "لتحقيق الغرض من المنصة، تتم مشاركة طلب عرض السعر وتفاصيل المشروع ذات الصلة مع موردين ومقاولين وشركات هندسية مؤهلين في شبكتنا ليتمكنوا من تقديم عروض تنافسية. نشارك فقط المعلومات اللازمة لرد الشركاء على طلبك." },
        { title: "إجراءات الأمان", body: "نطبّق تدابير تقنية وتنظيمية معقولة لحماية معلوماتك من الوصول غير المصرح به أو الفقدان أو سوء الاستخدام. ومع ذلك، لا توجد وسيلة نقل أو تخزين آمنة تماماً." },
        { title: "حقوقك", body: "يمكنك طلب الوصول إلى معلوماتك الشخصية أو تصحيحها أو حذفها في أي وقت بالتواصل معنا. سنستجيب للطلبات المشروعة وفقاً للأنظمة المعمول بها." },
        { title: "تواصل معنا", body: "إذا كان لديك أي استفسار حول سياسة الخصوصية أو كيفية التعامل مع بياناتك، يرجى التواصل معنا عبر القنوات الموضحة في صفحة اتصل بنا." },
      ],
    },
    termsPage: {
      label: "الشروط والأحكام",
      heading: "الشروط والأحكام",
      updated: "آخر تحديث: يونيو ٢٠٢٦",
      intro: "تحكم هذه الشروط والأحكام استخدامك لمنصة تاورلينك. باستخدامك للمنصة أو تقديم طلب عرض سعر، فإنك توافق على هذه الشروط.",
      sections: [
        { title: "طبيعة المنصة", body: "تاورلينك منصة لمطابقة الأعمال وطلبات عروض الأسعار. تاورلينك ليست مقاولاً أو مورداً أو استشارياً أو منفذاً للمشاريع. نحن لا نصنّع أو نورّد أو نركّب أو ننفّذ أي أعمال بأنفسنا." },
        { title: "دورنا", body: "تعمل تاورلينك وسيطاً فقط يربط أصحاب المشاريع بموردين ومقاولين وشركات هندسية مؤهلين، ويسهّل تبادل المتطلبات وعروض الأسعار بينهم." },
        { title: "الاتفاقيات بين الأطراف", body: "أي عرض سعر أو تفاوض أو عقد أو اتفاق ينتج عن المنصة يكون حصرياً بين العميل والمورد أو المقاول المختار. تاورلينك ليست طرفاً في أي اتفاق من هذا القبيل." },
        { title: "عدم الضمان", body: "لا تضمن تاورلينك دقة عروض الأسعار أو توفر المنتجات أو الخدمات أو أداء أي شريك أو نتيجة أي مشروع. جميع العروض مقدمة من شركاء خارجيين." },
        { title: "مسؤوليات المستخدم", body: "أنت مسؤول عن تقديم معلومات دقيقة في طلباتك، وعن تقييم العروض التي تستلمها، وعن إجراء العناية الواجبة قبل الدخول في أي اتفاق." },
        { title: "حدود المسؤولية", body: "إلى أقصى حد يسمح به القانون، لن تكون تاورلينك مسؤولة عن أي خسارة أو ضرر ينشأ عن استخدام المنصة أو عن أي اتفاق أو تعامل بين العميل والشريك." },
        { title: "تعديل الشروط", body: "قد نحدّث هذه الشروط والأحكام من وقت لآخر. استمرار استخدام المنصة بعد التعديلات يعني قبول الشروط المحدّثة." },
      ],
    },
    disclaimerPage: {
      label: "إخلاء المسؤولية",
      heading: "إخلاء المسؤولية",
      updated: "آخر تحديث: يونيو ٢٠٢٦",
      intro: "تاورلينك منصة لمطابقة الأعمال تربط أصحاب المشاريع بموردين ومقاولين وشركات هندسية مؤهلين. ينطبق إخلاء المسؤولية التالي على كل استخدام للمنصة.",
      sections: [
        { title: "دور المنصة فقط", body: "تسهّل تاورلينك فقط الربط وتبادل طلبات وعروض الأسعار بين العملاء والشركاء الخارجيين. نحن لسنا مورداً أو مقاولاً أو استشارياً أو منفذاً للمشاريع." },
        { title: "لسنا مسؤولين عن", body: "• أداء الموردين\n• نزاعات العقود\n• دقة الأسعار\n• تنفيذ المشاريع\n• نزاعات الدفع\n• خدمات الأطراف الخارجية" },
        { title: "قرارات مستقلة", body: "أي قرار بالتعاقد مع مورد أو مقاول، وأي اتفاق ناتج عن ذلك، يتخذه العميل بشكل مستقل. لا تصادق تاورلينك على أي شريك ولا تضمنه." },
        { title: "بدون ضمان", body: "تُقدَّم المنصة ومحتواها \"كما هي\" دون أي ضمانات من أي نوع. لا تضمن تاورلينك أن تكون المنصة دون انقطاع أو خالية من الأخطاء أو أن تلبي عروض الأسعار متطلباتك." },
        { title: "حدود المسؤولية", body: "لن تتحمل تاورلينك أي مسؤولية عن أي خسارة مباشرة أو غير مباشرة أو تبعية تنشأ عن التعاملات بين العملاء والشركاء أو عن الاعتماد على المعلومات المقدمة عبر المنصة." },
      ],
    },
    partnersPage: {
      label: "الشركاء",
      heading: "انضم إلى شبكة شركاء TowerLink",
      intro: "انضم إلى شبكة TowerLink المتنامية من الموردين والمقاولين والشركاء الهندسيين المعتمدين في المملكة العربية السعودية ودول الخليج. احصل على فرص مشاريع مؤهلة وتواصل مع أصحاب المشاريع من خلال منصة متخصصة لطلبات عروض الأسعار وحلول المشتريات في قطاع الاتصالات.",
      formHeading: "تسجيل شريك",
      companyName: "اسم الشركة",
      crNumber: "رقم السجل التجاري",
      contactPerson: "الشخص المسؤول",
      position: "المنصب",
      email: "البريد الإلكتروني",
      phone: "الهاتف",
      whatsapp: "واتساب",
      country: "الدولة",
      city: "المدينة",
      website: "الموقع الإلكتروني",
      categoriesLabel: "مجال العمل",
      categoriesHint: "اختر كل ما ينطبق",
      yearsExperience: "سنوات الخبرة",
      companyDescription: "وصف الشركة",
      docsLabel: "المستندات والشهادات",
      docsHint: "ارفع السجل التجاري، الملف التعريفي للشركة (PDF)، شهادات الأيزو، اعتمادات أرامكو / STC / SEC، وأي شهادات أخرى.",
      dropFiles: "اسحب وأفلت الملفات هنا، أو انقر للتصفح",
      uploading: "جاري الرفع...",
      submit: "إرسال التسجيل",
      successTitle: "تم استلام الطلب",
      successMsg: "شكراً لتسجيلكم في تاورلينك. تم استلام طلبكم وهو حالياً قيد المراجعة. سيقوم فريقنا بالتحقق من البيانات المقدمة قبل اعتماد الشركة كشريك.",
      yourPartnerId: "معرّف الشريك الخاص بكم",
      referenceLabel: "رقمك المرجعي",
      newRegistration: "إرسال تسجيل آخر",
      verifiedHeading: "شركاؤنا المعتمدون",
      verifiedSub: "شبكة متنامية من الموردين والمقاولين والشركات الهندسية المعتمدين في المملكة ودول الخليج.",
      verifiedEmpty: "شبكة شركائنا المعتمدين في نمو مستمر. سيظهر الشركاء المعتمدون هنا.",
      colPartnerId: "معرّف الشريك",
      colCategory: "الفئة",
      colCountry: "الدولة",
      colStatus: "الحالة",
      statusVerified: "شريك معتمد",
      invalidEmail: "أدخل بريداً إلكترونياً صحيحاً (مثال: name@example.com).",
      invalidPhone: "أدخل رقماً صحيحاً: ٨–١٥ رقماً، ويُسمح بعلامة + في البداية فقط.",
      requiredFields: "الرجاء إكمال جميع الحقول المطلوبة.",
      selectCategory: "الرجاء اختيار مجال عمل واحد على الأقل.",
    },
    homePartner: {
      eyebrow: "شبكة الشركاء",
      heading: "هل أنتم مورد أو مقاول أو شركة هندسية؟",
      text: "انضموا إلى شبكة شركاء TowerLink المعتمدين في المملكة العربية السعودية ودول الخليج.",
      support: "سجل شركتك، ارفع مستندات الاعتماد، واحصل على فرص مشاريع مؤهلة من خلال شبكة TowerLink المتنامية.",
      cta: "انضم إلى شبكة الشركاء",
      trust: [
        { title: "شبكة موثوقة", sub: "شركاء معتمدون" },
        { title: "فرص أكثر", sub: "مشاريع مستمرة" },
        { title: "تغطية إقليمية", sub: "في السعودية ودول الخليج" },
        { title: "معايير عالية", sub: "جودة واحترافية" },
      ],
    },
  },
};
